import React, { useState, useEffect } from 'react';
import './CardMobile.css';
import card from '../../assets/black-card.svg';
import carrito1 from '../../assets/carrito_1.svg';
import carritoEnough from '../../assets/carrito_Enough.svg';
import carrito2 from '../../assets/carrito_2.svg';
import favoriteFull from '../../assets/fav_full.svg';
import Modal from '../../ui/Modal/Modal';
import { useDispatch } from 'react-redux';
import { getCarrito } from '../../redux/actions';
import favoriteIcon from '../../assets/fav_1.svg';
import axios from 'axios';
import ModalPromo from '../../ui/ModalPromo/ModalPromo';
import { trackEvent } from '../../utils/fbpPixel';
import hotweek from '../../assets/HotWeek_01.png';

export default function CardMobile({ nombre, carrito, setCarrito, price, imageUrl, item, priceOffert, favorite = false, dolar, isHome, deleteFav, admin, isFeatured }) {
    const token = localStorage.getItem('token');
    const [isHovered, setIsHovered] = useState(deleteFav ? 'on' : 'off');
    const [modal, setModal] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false);
    const [showVer, setShowVer] = useState(false);
    const [showFav, setShowFav] = useState(false);
    const [showCarrito, setShowCarrito] = useState(false);
    const dispatch = useDispatch();

    function calcularPorcentajeDiferencia(numero1, numero2) {
        const porcentajeDiferencia = 100 - (numero1 * 100 / numero2);
        return porcentajeDiferencia;
    }


    const isHoveredHandler = (hover) => {
        if (hover === 'enter' || hover === 'on') {
            setIsHovered('on');
        } else {
            setIsHovered('off');
        }
    };


    let porcentajePromo = Number(item.porcentaje_promo) || 0;
    let cantidadPromo = Number(item.cantidad_promo) || 0;

    let resultado;
    
    const itemPriceUSD = item.precio_dolar || 0;
    const itemPriceUSDOffert = item.precio_oferta_dolares || 0;
    const precioConIncremento = itemPriceUSDOffert && Number(item.porcentaje_promo) <= 0 ? itemPriceUSDOffert * dolar : item.precio_dolar * dolar;
    let label;
    if (porcentajePromo) {
        resultado = precioConIncremento * (1 - porcentajePromo / 100);
        label = `${porcentajePromo}% OFF`;
    } else if (cantidadPromo) {
        resultado = precioConIncremento - cantidadPromo;
    }

    const precioConDescuentoAdicional = resultado * 0.8;

    const precioFinal = precioConDescuentoAdicional.toFixed(0);

    const calculateInstallment = () => (resultado / 6).toFixed(2);

    const porcentajeDiferencia = itemPriceUSDOffert
        ? `${Math.abs(
            ((100 - (itemPriceUSDOffert * 100) / itemPriceUSD) + porcentajePromo).toFixed(0)
        )}% OFF`
        : '';

    const [installmentPrice, installmentDecimal] = calculateInstallment().split(
        '.'
    );
    const objFav = {
        token,
        idproducto: item.idproducto,
        isDelete: false
    }

    const objFavDelete = {
        token,
        idproducto: item.idproducto,
        isDelete: true
    }

    const objAddCart = {
        token,
        idproducto: item.idproducto,
        cantidad: 1
    }

    const handleAddCart = async () => {
        if (token) {
          // Usuario autenticado
          try {
            const objAddCart = {
              token,
              idproducto: item.idproducto,
              cantidad: 1,
            };
      
            await axios.post(
              'https://dk8qbwpywj.execute-api.us-east-1.amazonaws.com/prod/agregar-carrito',
              {
                httpMethod: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                queryStringParameters: {},
                pathParameters: {},
                body: JSON.stringify(objAddCart),
                isBase64Encoded: false,
              }
            );
      
            // Actualizar el estado global del carrito
            dispatch(getCarrito(token));
            setCarrito(true);
          } catch (error) {
            console.error('Error al agregar al carrito en el backend:', error);
            // Opcional: Mostrar una notificación al usuario
          }
        } else {
          // Usuario no autenticado: manejar el carrito en localStorage
          try {
            const carritoLocal = JSON.parse(localStorage.getItem('carrito-sce-product-manager')) || [];
      
            const existingItemIndex = carritoLocal.findIndex(
              (prod) => prod.idproducto === item.idproducto
            );
      
            if (existingItemIndex !== -1) {
              // Incrementar la cantidad si el producto ya está en el carrito
              carritoLocal[existingItemIndex].cantidad += 1;
            } else {
              // Agregar un nuevo producto al carrito
              carritoLocal.push({
                idproducto: item.idproducto,
                nombre: nombre,
                precio: precioFinal,
                cantidad: 1,
                imageUrl: imageUrl,
                // Puedes agregar más propiedades si lo deseas
              });
            }
      
            // Guardar el carrito actualizado en localStorage
            localStorage.setItem('carrito-sce-product-manager', JSON.stringify(carritoLocal));
      
            // Opcional: Actualizar el estado local para reflejar cambios en la UI
            setCarrito(true);
          } catch (error) {
            console.error('Error al agregar al carrito en localStorage:', error);
            // Opcional: Mostrar una notificación al usuario
          }
        }
      
        // Registrar el evento de seguimiento (tracking)
        trackEvent('AddToCart', {
          content_name: item.nombre,
          content_ids: [String(item.idproducto)],
          content_type: 'product',
          value: Number(precioFinal),
          currency: 'ARS',
        });
      };

    const addFavorite = async () => {
        if (!token) return window.location.href = '/ingresar';
        const response = await axios.post(`https://dk8qbwpywj.execute-api.us-east-1.amazonaws.com/prod/sce-agregar-favoritos`, {
            httpMethod: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            queryStringParameters: {},
            pathParameters: {},
            body: JSON.stringify(objFav),
            isBase64Encoded: false,
        });
        const carritoData = JSON.parse(response.data.body);
        if (carritoData.error) {
            localStorage.removeItem('token');
            window.location.href = '/ingresar';
        }
    }

    const deleteFavorite = async () => {
        const response = await axios.post(`https://dk8qbwpywj.execute-api.us-east-1.amazonaws.com/prod/sce-agregar-favoritos`, {
            httpMethod: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            queryStringParameters: {},
            pathParameters: {},
            body: JSON.stringify(objFavDelete),
            isBase64Encoded: false,
        });
        const carritoData = JSON.parse(response.data.body);
        if (carritoData.error) {
            localStorage.removeItem('token');
            window.location.href = '/ingresar';
        }
    }
    const [precio, decimal] = calculateInstallment().split('.');

    return (
        <div
            className={`relative pb-20 mb-20 lg:w-[309px] w-full rounded-[4px] ${favorite ? 'h-72' : 'lg:h-[401px] h-[636px]'} ${showTooltip ? 'hovered' : ''}`}
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
        >
            <div className={`flex ${label ? 'justify-end' : 'lg:ml-8'}`}>
                {label && Number(precioFinal) !== 0 && (
                    <div className="absolute top-5 bg-[#E40F1B] text-sm rounded-l-md text-white px-3">{label}</div>
                )}
                <div className="absolute top-5 left-5">
                    <img src={hotweek} alt="Hot Week" className="w-24" />
                </div>
                <a href={`/producto/${item.slug ? item.slug : ''}${item.slug ? '-' : ''}${item.idproducto}`}>
                    <img
                        src={`https://sistema.depcsuite.com/productos/${imageUrl}`}
                        alt="Producto"
                        className={`${favorite ? "w-60" : `${isHome ? 'w-72 lg:mr-3' : 'w-full lg:mr-3'}`} mb-3 ${isHome ? 'lg:mr-2' : ''}`}
                    />
                </a>
            </div>
            {!favorite && <div className={`flex flex-col text-center lg:ml-0 ${label ? '' : ''}`}>
                <div className='flex flex-row gap-4 justify-center items-center'>
                    <div className="flex justify-center h-[46px] w-[46px] rounded-md items-center bg-white shadow-xl">
                        {isHovered === 'on' ?
                            <button onClick={() => {
                                deleteFavorite();
                                isHoveredHandler('off')
                            }}
                            >
                                <img src={favoriteFull} className='items-center' alt="" />
                            </button>
                            :
                            <button onClick={() => {
                                addFavorite()
                                isHoveredHandler('on')
                            }}
                                onMouseEnter={() => setShowFav(true)}
                                onMouseLeave={() => setShowFav(false)}
                            >
                                {!showFav ?
                                    <img src={favoriteIcon} className='items-center' alt="" />
                                    :
                                    <img src={favoriteFull} className='items-center' alt="" />
                                }
                            </button>
                        }
                    </div>
                    <div>
                        {(Number(precioFinal) !== 0 && Number(item.cantidad) != 0) ?
                            <button
                                onClick={() => {
                                    handleAddCart();
                                    setCarrito(true);
                                }}
                                className="flex justify-center h-[46px] w-[46px] rounded-md items-center bg-white shadow-xl"
                                onMouseEnter={() => setShowCarrito(true)}
                                onMouseLeave={() => setShowCarrito(false)}
                            >
                                {!showCarrito ?
                                    <img src={carrito1} className='items-center' alt="" />
                                    :
                                    <img src={carrito2} className='items-center' alt="" />
                                }
                            </button> :
                            <div
                                className="flex justify-center h-[46px] w-[46px] rounded-md items-center bg-white shadow-xl"
                                onMouseEnter={() => setShowCarrito(true)}
                                onMouseLeave={() => setShowCarrito(false)}
                            >
                                <img src={carritoEnough} className='items-center' alt="" />
                            </div>
                        }
                    </div>
                </div>
                <div className={`${isFeatured ? 'text-sm text-left justify-start items-start' : 'text-lg px-10 justify-center items-center text-center'} pt-6 flex mb-1 font-semibold ${label ? '' : ''}`}>{nombre}</div>
                <div className={`${isFeatured ? 'text-lg text-left justify-start items-start' : 'text-[18px]'}`}>
                    <div className={`${isFeatured ? 'text-base text-left justify-start items-start' : 'text-sm font-regularQuicksand mt-2'}`}>
                        <span className="mr-2 line-through">{Number(precioConIncremento) !== 0 && Number(item.cantidad) != 0 ? Number(precioConIncremento).toLocaleString("es-AR", {
                            style: "currency",
                            currency: "ARS",
                            maximumFractionDigits: 0,
                        }) + ' de lista' : ''}</span>
                    </div>
                    <div className={`${isFeatured ? 'text-base text-left justify-start items-start font-semiBoldQuicksand text-red-600' : 'text-sm font-boldQuicksand text-red-600 mt-2'}`}>
                        <span className="mr-2 ">{Number(resultado) !== 0 && Number(item.cantidad) != 0 ? Number(resultado).toLocaleString("es-AR", {
                            style: "currency",
                            currency: "ARS",
                            maximumFractionDigits: 0,
                        }) + ` Promo HotWeek ${item.porcentaje_promo || item.cantidad_promo}% `: ''}</span>
                    </div>
                    {Number(precioFinal) !== 0 && Number(item.cantidad) != 0 && <div className={`flex ${isFeatured ? 'text-base text-left justify-start items-start' : 'justify-center mt-2'} flex-row `}>
                        <img src={card} alt="Icono" className="w-3.5 mt-3" />
                        <span className="text-[12px] mt-1 ml-1">6 cuotas de </span>
                        <span className="font-semibold ml-1 mt-1 text-[11px]">{Number(installmentPrice).toLocaleString("es-AR", {
                            style: "currency",
                            currency: "ARS",
                            maximumFractionDigits: 0,
                        })}</span>
                        <span className="font-semibold text-[7px] ml-[2px]">{installmentDecimal}</span>
                    </div>}
                    <span className="mr-2 font-semibold">{Number(precioFinal) !== 0 && Number(item.cantidad) != 0 ? Number(precioFinal).toLocaleString("es-AR", {
                        style: "currency",
                        currency: "ARS",
                        maximumFractionDigits: 0,
                    }) : 'AGOTADO'}</span>
                    {<span className="opacity-90 line-through">{Number(itemPriceUSDOffert) !== 0 && Number((itemPriceUSDOffert * dolar) * 0.80).toLocaleString("es-AR", {
                        style: "currency",
                        currency: "ARS",
                        maximumFractionDigits: 0,
                    })}</span>}
                    <br/>
                    <strong className="text-xs">
                    20% adicional con transferencia
                    </strong>
                </div>
            </div>}
            <ModalPromo
                isOpen={modal}
                setIsOpen={setModal}
                item={item}
                carrito={carrito}
                setCarrito={setCarrito}
                precioFinal={precioFinal}
                precioConIncremento={precioConIncremento}
            />
        </div>
    );
}